import { LinearProgress } from "@mui/material";

export const Progress = ({ text }) => (
  <div>
    <LinearProgress />
    <br />
    {text}
  </div>
);
